/* eslint-disable no-useless-concat */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';

import UIGrid from '../uigrid';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'; // Optional theme CSS

let isFlag = '';
const StageTable = (props) => {
  const { stageData, unit_set_dict, translateObject } = props;
  const [stageRowData1, setStageRowData1] = useState([]);
  const tblData = stageData.pres_vessels[0].module;
  const tableData = stageData;
  function getValue(item, num) {
    return Number.parseFloat(item).toFixed(num);
  }
  function getFluxValue(item, num) {
    if (unit_set_dict.Flux === 'm/s') {
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  }
  function getFlowValue(item, num) {
    if (unit_set_dict['Volume Flow'] === 'm3/s') {
      if (item >= 0.01) {
        return Number.parseFloat(item).toFixed(num);
      }
      return Number.parseFloat(item).toExponential(num);
    }
    return Number.parseFloat(item).toFixed(num);
  }

  const [stageColData1] = useState([
    { tag: 'element', hdata: `${translateObject('Element No.')}`, datatype: 'text', maxWidth: 50, minWidth: 20, decimalValue: 2, disabled: true },
    {
      tag: 'feedflow', hdata: `${translateObject('Feed Flow')} 
      (${unit_set_dict['Volume Flow'] ? unit_set_dict['Volume Flow'] : 'gpm'})`, datatype: 'text',
      maxWidth: 100, minWidth: 20, decimalValue: 2, disabled: true
    },
    {
      tag: 'perm', hdata: `${translateObject('Perm Flow')} 
      (${unit_set_dict['Volume Flow'] ? unit_set_dict['Volume Flow'] : 'gpm'})`, datatype: 'text',
      maxWidth: 100, minWidth: 20, decimalValue: 2, disabled: true
    },
    { tag: 'recovery', hdata: `% ${translateObject('Recovery')}`, maxWidth: 100, minWidth: 20, datatype: 'text', decimalValue: 2, disabled: true },
    { tag: 'conc', hdata: 'Conc. Pol', maxWidth: 100, minWidth: 20, datatype: 'text', decimalValue: 2, disabled: true },
    {
      tag: 'feed', hdata: `${translateObject('Feed Pressure')} (${unit_set_dict.Pressure ? unit_set_dict.Pressure : 'atm'})`, datatype: 'text',
      maxWidth: 100, minWidth: 20, decimalValue: 2, disabled: true
    },
    {
      tag: 'net', hdata: `${translateObject('Net Pressure')} (${unit_set_dict.Pressure ? unit_set_dict.Pressure : 'atm'})`, datatype: 'text',
      maxWidth: 100, minWidth: 20, decimalValue: 2, disabled: true
    },
    {
      tag: 'dp', hdata: `DP (${unit_set_dict.Pressure ? unit_set_dict.Pressure : 'atm'})`, datatype: 'text',
      maxWidth: 50, minWidth: 20, decimalValue: 2, disabled: true
    },
    {
      tag: 'flux', hdata: `${translateObject('Flux')} (${unit_set_dict.Flux ? unit_set_dict.Flux : 'gfd'})`, datatype: 'text',
      maxWidth: 100, minWidth: 20, decimalValue: 2, disabled: true
    },
    { tag: 'avalue', hdata: ' AValue (um/(s-MPa)) ', maxWidth: 70, minWidth: 20, datatype: 'text', decimalValue: 2, disabled: true }
  ]);

  useEffect(() => {
    const stagearr_rowdata1 = [];
    tblData.map((data, i) => {
      stagearr_rowdata1.push({
        element: i + 1, feedflow: getFlowValue(data.feed_flow, 2), perm: getFlowValue(data.perm_flow, 2),
        recovery: getValue(data.recovery, 2), conc: getValue(data.beta, 2),
        feed: getValue(data.feed_press, 2), net: getValue(data.net_press, 2), dp: getValue(data.dp, 2),
        flux: getFluxValue(data.flux, 2), avalue: getValue(data.avalue_op, 2)
      });
    });

    setStageRowData1(stagearr_rowdata1);
    isFlag = stageData.unique_id;
  }, (isFlag === stageData.unique_id) ? [null] : [stageRowData1]);

  const elemRowData = [
    {
      Ions: 'Ca', feed: getValue(tableData.feed_ppm['Ca++'], 2), perm: getValue(tableData.perm_ppm['Ca++'], 2),
      conc: getValue(tableData.conc_ppm['Ca++'], 2)
    },
    {
      Ions: 'Mg', feed: getValue(tableData.feed_ppm['Mg++'], 2), perm: getValue(tableData.perm_ppm['Mg++'], 2),
      conc: getValue(tableData.conc_ppm['Mg++'], 2)
    },
    {
      Ions: 'Na', feed: getValue(tableData.feed_ppm['Na+'], 2), perm: getValue(tableData.perm_ppm['Na+'], 2),
      conc: getValue(tableData.conc_ppm['Na+'], 2)
    },
    {
      Ions: 'K', feed: getValue(tableData.feed_ppm['K+'], 2), perm: getValue(tableData.perm_ppm['K+'], 2),
      conc: getValue(tableData.conc_ppm['K+'], 2)
    },
    {
      Ions: 'NH4', feed: getValue(tableData.feed_ppm['NH4+'], 2), perm: getValue(tableData.perm_ppm['NH4+'], 2),
      conc: getValue(tableData.conc_ppm['NH4+'], 2)
    },
    {
      Ions: 'Ba', feed: getValue(tableData.feed_ppm['Ba++'], 2), perm: getValue(tableData.perm_ppm['Ba++'], 2),
      conc: getValue(tableData.conc_ppm['Ba++'], 2)
    },
    {
      Ions: 'Sr', feed: getValue(tableData.feed_ppm['Sr++'], 2), perm: getValue(tableData.perm_ppm['Sr++'], 2),
      conc: getValue(tableData.conc_ppm['Sr++'], 2)
    },
    {
      Ions: 'Fe', feed: getValue(tableData.feed_ppm['Fe++'], 2), perm: getValue(tableData.perm_ppm['Fe++'], 2),
      conc: getValue(tableData.conc_ppm['Fe++'], 2)
    },
    {
      Ions: 'Mn', feed: getValue(tableData.feed_ppm['Mn++'], 2), perm: getValue(tableData.perm_ppm['Mn++'], 2),
      conc: getValue(tableData.conc_ppm['Mn++'], 2)
    },
    {
      Ions: 'SO4', feed: getValue(tableData.feed_ppm['SO4--'], 2), perm: getValue(tableData.perm_ppm['SO4--'], 2),
      conc: getValue(tableData.conc_ppm['SO4--'], 2)
    },
    {
      Ions: 'Cl', feed: getValue(tableData.feed_ppm['Cl-'], 2), perm: getValue(tableData.perm_ppm['Cl-'], 2),
      conc: getValue(tableData.conc_ppm['Cl-'], 2)
    },
    {
      Ions: 'F', feed: getValue(tableData.feed_ppm['F-'], 2), perm: getValue(tableData.perm_ppm['F-'], 2),
      conc: getValue(tableData.conc_ppm['F-'], 2)
    },
    {
      Ions: 'NO3', feed: getValue(tableData.feed_ppm['NO3-'], 2), perm: getValue(tableData.perm_ppm['NO3-'], 2),
      conc: getValue(tableData.conc_ppm['NO3-'], 2)
    },
    {
      Ions: 'Br', feed: getValue(tableData.feed_ppm['Br-'], 2), perm: getValue(tableData.perm_ppm['Br-'], 2),
      conc: getValue(tableData.conc_ppm['Br-'], 2)
    },
    {
      Ions: 'PO4', feed: getValue(tableData.feed_ppm['PO4---'], 2), perm: getValue(tableData.perm_ppm['PO4---'], 2),
      conc: getValue(tableData.conc_ppm['PO4---'], 2)
    },
    {
      Ions: 'B', feed: getValue(tableData.feed_ppm['B-'], 2), perm: getValue(tableData.perm_ppm['B-'], 2),
      conc: getValue(tableData.conc_ppm['B-'], 2)
    },
    {
      Ions: 'SiO2', feed: getValue(tableData.feed_ppm.SiO2, 2), perm: getValue(tableData.perm_ppm.SiO2, 2),
      conc: getValue(tableData.conc_ppm.SiO2, 2)
    },
    {
      Ions: 'H2S', feed: getValue(tableData.feed_ppm.H2S, 2), perm: getValue(tableData.perm_ppm.H2S, 2),
      conc: getValue(tableData.conc_ppm.H2S, 2)
    },
    {
      Ions: 'HCO3', feed: getValue(tableData.feed_ppm['HCO3-'], 2), perm: getValue(tableData.perm_ppm['HCO3-'], 2),
      conc: getValue(tableData.conc_ppm['HCO3-'], 2)
    },
    {
      Ions: 'CO2', feed: getValue(tableData.feed_ppm.CO2, 2), perm: getValue(tableData.perm_ppm.CO2, 2),
      conc: getValue(tableData.conc_ppm.CO2, 2)
    },
    {
      Ions: 'CO3', feed: getValue(tableData.feed_ppm['CO3--'], 2), perm: getValue(tableData.perm_ppm['CO3--'], 2),
      conc: getValue(tableData.conc_ppm['CO3--'], 2)
    },
    {
      Ions: 'TDS', feed: getValue(tableData.feed_tds, 2), perm: getValue(tableData.perm_tds, 2),
      conc: getValue(tableData.conc_tds, 2)
    },
    {
      Ions: 'pH', feed: getValue(tableData.feed_ph, 2), perm: getValue(tableData.perm_ph, 2),
      conc: getValue(tableData.conc_ph, 2)
    },
    {
      Ions: `Pi.${unit_set_dict.Pressure ? unit_set_dict.Pressure : 'bar'}`,
      feed: getValue(tableData.feed_pi, 2),
      perm: getValue(tableData.perm_pi, 2),
      conc: getValue(tableData.conc_pi, 2)
    },
    {
      Ions: 'Conductivity', feed: getValue(tableData.feed_cond, 2), perm: getValue(tableData.perm_cond, 2),
      conc: getValue(tableData.conc_cond, 2)
    },
    {
      Ions: 'Hardness', feed: getValue(tableData.feed_hardness, 2), perm: getValue(tableData.perm_hardness, 2),
      conc: getValue(tableData.conc_hardness, 2)
    },
    {
      Ions: 'Density', feed: getValue(tableData.feed_density, 2), perm: getValue(tableData.perm_density, 2),
      conc: getValue(tableData.conc_density, 2)
    },
    {
      Ions: 'Ionic Str', feed: getValue(tableData.feed_is, 2), perm: getValue(tableData.perm_is, 2),
      conc: getValue(tableData.conc_is, 2)
    },
  ];

  const [elemColData] = useState([
    { tag: 'Ions', hdata: 'Ion', datatype: 'text', disabled: true },
    {
      tag: 'feed', hdata: 'Feed <div>(mg/l)</div>', datatype: 'text', disabled: true
    },
    {
      tag: 'perm', hdata: 'Perm. <div>(mg/l)</div>', datatype: 'text', disabled: true
    },
    {
      tag: 'conc', hdata: 'Conc. <div>(mg/l)</div>', datatype: 'text', disabled: true
    }
  ]);
  return (
    <div className="App">
      <Grid container justifyContent="space-between" alignItems="stretch">
        <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
          <div className="stage_table_01" style={{ height: '100%' }}>
            <UIGrid
              data={stageRowData1}
              properties={stageColData1}
            />
          </div>
        </Grid>
        <Grid item xs>
          <div className="stage_table_02" style={{ height: '550px' }}>
            <UIGrid
              data={elemRowData}
              properties={elemColData}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default StageTable;